/**
 * Minimal surface to derive comuna from `barrio_id` without coupling feature modules.
 * E.g. {@link PuntosEntregaShellPort} implements it; redemption only needs this for PDFs.
 */
export type BarrioComunaRow = { id: number; nombre: string };

export type BarrioComunaLookup = {
  listComunas(): ReadonlyArray<BarrioComunaRow>;
  listBarriosByComuna(comunaId: number): ReadonlyArray<BarrioComunaRow>;
};

/** Printable `Comuna N — nombre` label for PDFs (corregimiento / bonus-form context). */
export function comunaEtiquetaDesdeBarrio(lookup: BarrioComunaLookup, barrioId: number): string {
  if (barrioId <= 0) return '—';
  for (const c of lookup.listComunas()) {
    if (lookup.listBarriosByComuna(c.id).some((b) => b.id === barrioId)) {
      return `Comuna ${c.id} — ${c.nombre}`;
    }
  }
  return '—';
}
